// import React, { useEffect, useRef, useState } from "react";
// import { Button, Table, Pagination, Row, Col } from "react-bootstrap";
// import { BsFiletypeXls } from "react-icons/bs";
// import { MdFilterAltOff, MdFilterAlt } from "react-icons/md";
// import { RiFilterFill } from "react-icons/ri";
// import Swal from "sweetalert2";
// import { FaCalendar, FaTimes } from "react-icons/fa";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";

// const API_URL = process.env.REACT_APP_API_URL;

// function MonthlyORSpecialSelfOffers() {
//   const [ledger, setLedger] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [searchTerm, setSearchTerm] = useState({ amount: "", type: "" });
//   const [showFilter, setShowFilter] = useState(false);
//   const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1199);
//   const [totals, setTotals] = useState({ total_credit: 0, total_debit: 0 });
//   const token = localStorage.getItem("token");
//   const [filterFromDate, setFilterFromDate] = useState("");
//   const [filterToDate, setFilterToDate] = useState("");
//   const [filterToType, setFilterToType] = useState("");
//   const [isFilterActive, setIsFilterActive] = useState(false);

//   const datePickerRef = useRef(null);
//   const handleIconClick = () => {
//     datePickerRef.current.setOpen(true);
//   };
//   const handleClear = () => {
//     setFilterFromDate(null);
//   };

//   const pageLimit = 10;

//   const showCustomMessageModal = (title, text) => {
//     alert(`${title}: ${text}`);
//   };

//   const handleToggle = () => {
//     setIsFilterActive(!isFilterActive);
//   };

//   useEffect(() => {
//     const handleResize = () => {
//       if (window.innerWidth >= 1199) {
//         setIsDesktop(true);
//         setShowFilter(true);
//       } else {
//         setIsDesktop(false);
//         setShowFilter(false);
//       }
//     };

//     handleResize();
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const fetchLedger = async (page = 1) => {
//     setLoading(true);
//     try {
//       const params = new URLSearchParams({
//         gift_type: searchTerm.gift_type || filterToType,
//         date_from: formatDateForServer(filterFromDate),
//         date_to: formatDateForServer(filterToDate),
//         page,
//       });

//       const response = await fetch(
//         `${API_URL}/gift-eligibility-list?${params}`,
//         {
//           method: "GET",
//           headers: { Authorization: `Bearer ${token}` },
//         },
//       );

//       const result = await response.json();

//       if (result.success === "1" || result.success === true) {
//         setLedger(result.data || []);
//         setTotalPages(result.total_pages || 1);
//         setCurrentPage(result.current_page || 1);
//       } else {
//         showCustomMessageModal(
//           "Error",
//           result.message || "Failed to fetch records.",
//         );
//       }
//     } catch (error) {
//       console.error("Fetch error:", error);
//       showCustomMessageModal("Error", "Failed to fetch ledger data.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchLedger();
//   }, []);

//   const handleSearch = (e) => {
//     e.preventDefault();
//     fetchLedger(1);
//   };

//   const handlePageChange = (pageNumber) => {
//     if (pageNumber >= 1 && pageNumber <= totalPages) {
//       fetchLedger(pageNumber);
//     }
//   };

//   const getPaginationGroup = () => {
//     const start = Math.floor((currentPage - 1) / pageLimit) * pageLimit;
//     return new Array(Math.min(pageLimit, totalPages - start))
//       .fill()
//       .map((_, idx) => start + idx + 1);
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "-";
//     try {
//       const date = new Date(dateString);
//       const day = String(date.getDate()).padStart(2, "0");
//       const month = String(date.getMonth() + 1).padStart(2, "0");
//       const year = date.getFullYear();
//       return `${day}-${month}-${year}`;
//     } catch (error) {
//       return "-";
//     }
//   };

//   const formatDateForServer = (date) => {
//     if (!date) return "";
//     const day = String(date.getDate()).padStart(2, "0");
//     const month = String(date.getMonth() + 1).padStart(2, "0");
//     const year = date.getFullYear();
//     return `${year}-${month}-${day}`;
//   };

//   const handleDownloadFilteredExcel = async () => {
//     const token = localStorage.getItem("token");

//     try {
//       Swal.fire({
//         title: "Please wait...",
//         text: "Generating your filtered Excel file",
//         allowOutsideClick: false,
//         didOpen: () => Swal.showLoading(),
//       });

//       const params = new URLSearchParams({
//         totalPages,
//         gift_type: searchTerm.gift_type || filterToType,
//         date_from: formatDateForServer(filterFromDate),
//         date_to: formatDateForServer(filterToDate),
//       }).toString();

//       const response = await fetch(
//         `${API_URL}/download-property-income-excel-by-associate?${params}`,
//         {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         },
//       );

//       if (!response.ok) throw new Error("Failed to download Excel");

//       const blob = await response.blob();
//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", `Filtered Users Wallet Ledger Report.xlsx`);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();

//       Swal.fire({
//         icon: "success",
//         title: "Download Successful!",
//         text: "Filtered Excel report has been downloaded successfully.",
//         showConfirmButton: false,
//         timer: 2000,
//       });
//     } catch (error) {
//       console.error("Filtered Excel download failed:", error);
//       Swal.fire({
//         icon: "warning",
//         title: "Download Failed!",
//         text: "Please Check Entered From Date & To Date For Downloading Self, Monthly Offers or Special Offers Lists Report.",
//       });
//     }
//   };

//   return (
//     <div className="padding_15">
//       <div className="userlist">
//         <div className="card shadow-sm">
//           <div className="card-header d-flex justify-content-between align-items-center gap-2">
//             <div className="titlepage">
//               <h3 style={{ whiteSpace: "wrap" }}>
//                 Self, Monthly Offers or Special Offers Lists
//               </h3>
//             </div>

//             <div className="d-flex gap-2 align-items-center">
//               <button
//                 className={`filter-toggle-btn btn btn-primary ${isFilterActive ? "active" : ""}`}
//                 onClick={handleToggle}
//               >
//                 {isFilterActive ? <MdFilterAltOff /> : <MdFilterAlt />}
//               </button>
//             </div>
//           </div>

//           {isFilterActive && (
//             <div className="card-body pb-0">
//               <Row className="mb-3 gy-2">
//                 <Col md={4} style={{ position: "relative" }}>
//                   <div
//                     className="position-absolute"
//                     style={{ top: "10px", right: "20px" }}
//                   >
//                     {!filterFromDate ? (
//                       <FaCalendar onClick={handleIconClick} />
//                     ) : (
//                       <FaTimes onClick={handleClear} />
//                     )}
//                   </div>
//                   <DatePicker
//                     ref={datePickerRef}
//                     selected={filterFromDate}
//                     onChange={(date) => setFilterFromDate(date)}
//                     placeholderText="DD-MM-YYYY"
//                     dateFormat="dd-MM-yyyy"
//                     className="form-control"
//                     // isClearable={true}
//                     showPopperArrow={false}
//                   />
//                 </Col>

//                 <Col md={4} style={{ position: "relative" }}>
//                   <div
//                     className="position-absolute"
//                     style={{ top: "10px", right: "20px" }}
//                   >
//                     {!filterFromDate ? (
//                       <FaCalendar onClick={handleIconClick} />
//                     ) : (
//                       <FaTimes onClick={handleClear} />
//                     )}
//                   </div>
//                   <DatePicker
//                     ref={datePickerRef}
//                     selected={filterToDate}
//                     onChange={(date) => setFilterToDate(date)}
//                     placeholderText="DD-MM-YYYY"
//                     dateFormat="dd-MM-yyyy"
//                     className="form-control"
//                     // isClearable={true}
//                     showPopperArrow={false}
//                   />
//                 </Col>

//                 <Col md={3} className="d-flex gap-2">
//                   <Button className="d-flex gap-1" variant="primary" onClick={() => fetchLedger(1)}>
//                     <RiFilterFill /> Filter
//                   </Button>
//                   <Button
//                     className="buttonpadding d-flex gap-2 border border-white"
//                     variant="primary"
//                     onClick={handleDownloadFilteredExcel}
//                   >
//                     <BsFiletypeXls className="text-white fs-6" />
//                     Download
//                   </Button>
//                 </Col>
//               </Row>
//             </div>
//           )}

//           <div className="card-body">
//             {loading ? (
//               <div className="text-center py-5">
//                 <div className="spinner-border text-primary" role="status">
//                   <span className="visually-hidden">Loading...</span>
//                 </div>
//                 <p className="mt-2">Loading records...</p>
//               </div>
//             ) : (
//               <>
//                 <Table striped bordered hover responsive>
//                   <thead>
//                     <tr>
//                       <th>#</th>
//                       <th>Username</th>
//                       <th>Mobile</th>
//                       <th>Project Name</th>
//                       <th>Achieved Area (SQYD)</th>
//                       <th>Offer/Gift</th>
//                       <th>Gift Item</th>
//                       <th>Days Remaining</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {ledger.length === 0 ? (
//                       <tr>
//                         <td
//                           colSpan="8"
//                           className="text-center py-4 text-danger fw-bold"
//                         >
//                           <p className="text-muted mb-3 text-danger fw-bold">
//                             No data available for the selected filters.
//                           </p>
//                         </td>
//                       </tr>
//                     ) : (
//                       ledger.map((item, index) => (
//                         <tr key={item.user_id || index}>
//                           <td>{(currentPage - 1) * pageLimit + index + 1}</td>
//                           <td>{item.username || "-"}</td>
//                           <td>{item.mobile || "-"}</td>
//                           <td>{item.project_name || "-"}</td>
//                           <td>{item.achieved_area || "-"}</td>
//                           <td>{item.gift_name || "-"}</td>
//                           <td>{item.gift_item || "-"}</td>
//                           <td>{item?.days_remaining ?? "-"}</td>
//                         </tr>
//                       ))
//                     )}
//                   </tbody>
//                 </Table>

//                 {ledger.length > 0 && totalPages > 1 && (
//                   <div className="d-flex justify-content-end mt-3">
//                     <Pagination>
//                       <Pagination.Prev
//                         onClick={() => handlePageChange(currentPage - 1)}
//                         disabled={currentPage === 1}
//                       />
//                       {getPaginationGroup().map((item, index) => (
//                         <Pagination.Item
//                           key={index}
//                           active={item === currentPage}
//                           onClick={() => handlePageChange(item)}
//                         >
//                           {item}
//                         </Pagination.Item>
//                       ))}
//                       <Pagination.Next
//                         onClick={() => handlePageChange(currentPage + 1)}
//                         disabled={currentPage === totalPages}
//                       />
//                     </Pagination>
//                   </div>
//                 )}
//               </>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default MonthlyORSpecialSelfOffers;

import React, { useEffect, useRef, useState } from "react";
import { Button, Table, Pagination, Row, Col } from "react-bootstrap";
import { BsFiletypeXls } from "react-icons/bs";
import { MdFilterAltOff, MdFilterAlt } from "react-icons/md";
import { RiFilterFill } from "react-icons/ri";
import Swal from "sweetalert2";
import { FaCalendar, FaTimes } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const API_URL = process.env.REACT_APP_API_URL;

function MonthlyORSpecialSelfOffers() {
  const [ledger, setLedger] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState({ amount: "", type: "" });
  const [showFilter, setShowFilter] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1199);
  const [totals, setTotals] = useState({ total_credit: 0, total_debit: 0 });
  const token = localStorage.getItem("token");
  const [filterFromDate, setFilterFromDate] = useState("");
  const [filterToDate, setFilterToDate] = useState("");
  const [filterToType, setFilterToType] = useState("");
  const [isFilterActive, setIsFilterActive] = useState(false);

  const datePickerRef = useRef(null);
  const handleIconClick = () => {
    datePickerRef.current.setOpen(true);
  };
  const handleClear = () => {
    setFilterFromDate(null);
  };

  const pageLimit = 10;

  const showCustomMessageModal = (title, text) => {
    alert(`${title}: ${text}`);
  };

  const handleToggle = () => {
    setIsFilterActive(!isFilterActive);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1199) {
        setIsDesktop(true);
        setShowFilter(true);
      } else {
        setIsDesktop(false);
        setShowFilter(false);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fetchLedger = async (page = 1) => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        gift_type: searchTerm.gift_type || filterToType,
        date_from: formatDateForServer(filterFromDate),
        date_to: formatDateForServer(filterToDate),
        page,
      });

      const response = await fetch(
        `${API_URL}/gift-eligibility-list?${params}`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      const result = await response.json();

      if (result.success === "1" || result.success === true) {
        setLedger(result.data || []);
        setTotalPages(result.total_pages || 1);
        setCurrentPage(result.current_page || 1);
      } else {
        showCustomMessageModal(
          "Error",
          result.message || "Failed to fetch records.",
        );
      }
    } catch (error) {
      console.error("Fetch error:", error);
      showCustomMessageModal("Error", "Failed to fetch ledger data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLedger();
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    fetchLedger(1);
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      fetchLedger(pageNumber);
    }
  };

  const getPaginationGroup = () => {
    const start = Math.floor((currentPage - 1) / pageLimit) * pageLimit;
    return new Array(Math.min(pageLimit, totalPages - start))
      .fill()
      .map((_, idx) => start + idx + 1);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    try {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    } catch (error) {
      return "-";
    }
  };

  const formatDateForServer = (date) => {
    if (!date) return "";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const handleDownloadFilteredExcel = async () => {
    const token = localStorage.getItem("token");

    try {
      Swal.fire({
        title: "Please wait...",
        text: "Generating your filtered Excel file",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      const params = new URLSearchParams({
        totalPages,
        gift_type: searchTerm.gift_type || filterToType,
        date_from: formatDateForServer(filterFromDate),
        date_to: formatDateForServer(filterToDate),
      }).toString();

      const response = await fetch(
        `${API_URL}/download-property-income-excel-by-associate?${params}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (!response.ok) throw new Error("Failed to download Excel");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `Filtered Users Wallet Ledger Report.xlsx`,
      );
      document.body.appendChild(link);
      link.click();
      link.remove();

      Swal.fire({
        icon: "success",
        title: "Download Successful!",
        text: "Filtered Excel report has been downloaded successfully.",
        showConfirmButton: false,
        timer: 2000,
      });
    } catch (error) {
      console.error("Filtered Excel download failed:", error);
      Swal.fire({
        icon: "warning",
        title: "Download Failed!",
        text: "Please Check Entered From Date & To Date For Downloading Self, Monthly Offers or Special Offers Lists Report.",
      });
    }
  };

  return (
    <>
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
          padding: "30px 24px",
          fontFamily: "'Poppins', 'DM Sans', sans-serif",
        }}
      >
        <div style={{ maxWidth: "1600px", margin: "0 auto" }}>
          {/* 🎯 HEADER CARD */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "16px",
              boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
              border: "1.5px solid #e2e8f0",
              padding: "20px 24px",
              display: "flex",
              alignItems: "center",
              gap: "16px",
              marginBottom: "20px",
              flexWrap: "wrap",
            }}
          >
            <div
              style={{
                width: "52px",
                height: "52px",
                borderRadius: "14px",
                background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#ffffff",
                fontSize: "24px",
                boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
                flexShrink: 0,
              }}
            >
              🏆
            </div>
            <div style={{ flex: 1, minWidth: "220px" }}>
              <h1
                style={{
                  margin: 0,
                  fontSize: "22px",
                  fontWeight: "800",
                  color: "#1e3a5f",
                  letterSpacing: "-0.5px",
                }}
              >
                Self, Monthly Offers or Special Offers Lists
              </h1>
              <p
                style={{
                  margin: "2px 0 0",
                  fontSize: "13px",
                  color: "#64748b",
                  fontWeight: "500",
                }}
              >
                View eligibility list for self, monthly & special offers
              </p>
            </div>

            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
              <button
                onClick={handleDownloadFilteredExcel}
                style={{
                  padding: "12px 18px",
                  borderRadius: "12px",
                  border: "none",
                  background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                  color: "#ffffff",
                  fontWeight: "700",
                  fontSize: "14px",
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  boxShadow: "0 4px 12px rgba(30, 87, 153, 0.25)",
                }}
              >
                <BsFiletypeXls /> Download
              </button>

              <button
                onClick={handleToggle}
                style={{
                  padding: "12px 16px",
                  borderRadius: "12px",
                  border: "1.5px solid #e2e8f0",
                  background: isFilterActive ? "#1e5799" : "#ffffff",
                  color: isFilterActive ? "#ffffff" : "#1e3a5f",
                  fontSize: "16px",
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                title="Toggle Filters"
              >
                {isFilterActive ? <MdFilterAltOff /> : <MdFilterAlt />}
              </button>
            </div>
          </div>

          {/* 🎯 MAIN CARD */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "16px",
              boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
              border: "1.5px solid #e2e8f0",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                height: "5px",
                background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
              }}
            />

            {/* Filters */}
            {isFilterActive && (
              <div
                style={{
                  padding: "20px 24px",
                  borderBottom: "1px solid #e2e8f0",
                }}
              >
                <Row className="gy-2 align-items-end">
                  <Col md={4}>
                    <label
                      style={{
                        display: "block",
                        fontSize: "12.5px",
                        fontWeight: "700",
                        color: "#1e3a5f",
                        marginBottom: "6px",
                      }}
                    >
                      From Date
                    </label>
                    <DatePicker
                      ref={datePickerRef}
                      selected={filterFromDate}
                      onChange={(date) => setFilterFromDate(date)}
                      placeholderText="DD-MM-YYYY"
                      dateFormat="dd-MM-yyyy"
                      className="form-control"
                      showPopperArrow={false}
                    />
                  </Col>

                  <Col md={4}>
                    <label
                      style={{
                        display: "block",
                        fontSize: "12.5px",
                        fontWeight: "700",
                        color: "#1e3a5f",
                        marginBottom: "6px",
                      }}
                    >
                      To Date
                    </label>
                    <DatePicker
                      selected={filterToDate}
                      onChange={(date) => setFilterToDate(date)}
                      placeholderText="DD-MM-YYYY"
                      dateFormat="dd-MM-yyyy"
                      className="form-control"
                      showPopperArrow={false}
                    />
                  </Col>

                  <Col md={4}>
                    <Button
                      variant="primary"
                      onClick={() => fetchLedger(1)}
                      style={{
                        borderRadius: "10px",
                        fontWeight: 700,
                        padding: "10px 20px",
                      }}
                    >
                      <RiFilterFill className="me-1" /> Filter
                    </Button>
                  </Col>
                </Row>
              </div>
            )}

            <div style={{ padding: "24px" }}>
              {loading ? (
                <div
                  style={{
                    textAlign: "center",
                    padding: "60px 20px",
                    color: "#64748b",
                  }}
                >
                  <div
                    style={{
                      width: "40px",
                      height: "40px",
                      border: "3px solid #cbd5e1",
                      borderTop: "3px solid #2b6cb0",
                      borderRadius: "50%",
                      display: "inline-block",
                      animation: "spin 0.8s linear infinite",
                    }}
                  />
                  <p
                    style={{
                      marginTop: "16px",
                      fontSize: "14px",
                      fontWeight: "600",
                    }}
                  >
                    Loading records...
                  </p>
                </div>
              ) : (
                <>
                  <div className="table-responsive">
                    <Table bordered hover>
                      <thead
                        style={{
                          background:
                            "linear-gradient(135deg, #1e5799, #2b6cb0)",
                          color: "#ffffff",
                        }}
                      >
                        <tr>
                          <th>#</th>
                          <th>Username</th>
                          <th>Mobile</th>
                          <th>Project Name</th>
                          <th>Achieved Area (SQYD)</th>
                          <th>Offer/Gift</th>
                          <th>Gift Item</th>
                          <th>Days Remaining</th>
                        </tr>
                      </thead>
                      <tbody>
                        {ledger.length === 0 ? (
                          <tr>
                            <td
                              colSpan="8"
                              className="text-center py-4"
                              style={{
                                color: "#dc2626",
                                fontWeight: "700",
                              }}
                            >
                              No data available for the selected filters.
                            </td>
                          </tr>
                        ) : (
                          ledger.map((item, index) => (
                            <tr key={item.user_id || index}>
                              <td>
                                {(currentPage - 1) * pageLimit + index + 1}
                              </td>
                              <td>{item.username || "-"}</td>
                              <td>{item.mobile || "-"}</td>
                              <td>{item.project_name || "-"}</td>
                              <td>{item.achieved_area || "-"}</td>
                              <td>{item.gift_name || "-"}</td>
                              <td>{item.gift_item || "-"}</td>
                              <td>{item?.days_remaining ?? "-"}</td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </Table>
                  </div>

                  {ledger.length > 0 && totalPages > 1 && (
                    <div className="d-flex justify-content-end mt-3">
                      <Pagination>
                        <Pagination.Prev
                          onClick={() => handlePageChange(currentPage - 1)}
                          disabled={currentPage === 1}
                        />
                        {getPaginationGroup().map((item, index) => (
                          <Pagination.Item
                            key={index}
                            active={item === currentPage}
                            onClick={() => handlePageChange(item)}
                          >
                            {item}
                          </Pagination.Item>
                        ))}
                        <Pagination.Next
                          onClick={() => handlePageChange(currentPage + 1)}
                          disabled={currentPage === totalPages}
                        />
                      </Pagination>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>

          {/* Footer */}
          <p
            style={{
              textAlign: "center",
              color: "#94a3b8",
              fontSize: "12.5px",
              marginTop: "24px",
              fontWeight: "500",
            }}
          >
            © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
            Rights Reserved.
          </p>
        </div>
      </div>

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </>
  );
}

export default MonthlyORSpecialSelfOffers;
